import React from 'react';

interface ScoutLoopMarkProps {
  size?: number;
  color?: string;
  className?: string;
}

export const ScoutLoopMark: React.FC<ScoutLoopMarkProps> = ({
  size = 32,
  color = '#d97706',
  className,
}) => (
  <svg
    viewBox="0 0 200 200"
    width={size}
    height={size}
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M 100 20 A 80 80 0 1 1 43.43 156.57"
      stroke={color}
      strokeWidth="22"
      strokeLinecap="butt"
      fill="none"
    />
    <circle cx="100" cy="100" r="14" fill={color} />
  </svg>
);
